import { swSettings } from "app/common/services/swSettings";

export const getPaidExcelProps = () => {
    return {
        isTargetForSubscriptionUpgrade: /(starter|explorer)/i.test(swSettings.user?.plan),
        excelChargeReadMoreHref: "https://support.similarweb.com/hc/en-us/articles/11550179057693",
    };
};
